import {Pair} from "../../../model/ResponsesDTO";
import {Button, ConfigProvider, message, Upload, UploadFile} from "antd";
import {isMobile} from "react-device-detect";
import {CloseCircleOutlined, DeleteOutlined, FilePdfOutlined, UploadOutlined} from "@ant-design/icons";
import {MenuWeekErrorPage} from "./MenuWeekEmptyPage";
import {UploadRequestOption} from 'rc-upload/lib/interface'
import {useAuth0} from "@auth0/auth0-react";
import {RcFile} from "antd/es/upload";
import {useState} from "react";
import {Chip} from "@mui/material";

export const MenuWeekElement : React.FC<{
    pair: Pair,
    handleSaveToDatabase: (e: UploadRequestOption) => Promise<() => void>,
    handleBeforeUpload: (file: RcFile) => File | boolean | string,
    handleDelete: (publicId: number) => Promise<() => void>,
    handleGetPdf: (publicId: number) => Promise<() => void>
}> = (props) => {

    const {pair, handleSaveToDatabase, handleBeforeUpload, handleDelete, handleGetPdf} = props
    const [menuWeeks,setMenuWeeks] = useState<UploadFile[]>([])
    const {
        user,
    } = useAuth0();

    return (
    <>
        {!user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
            <>
                <ConfigProvider
                    theme={{
                        components: {
                            Button: {
                                fontWeight: 500,
                                fontFamily: 'Montserrat, sans-serif',
                                fontSize: 18,
                                colorPrimary: '#C5B5F2',
                                colorPrimaryActive: '#C5B5F2',
                                colorPrimaryHover: '#d4bdff',
                            }
                        }
                    }}
                >
                    <div className={'my-2'} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: `${isMobile ? `100%` : `40%`}`}}>
                        <Upload
                            customRequest={(e : UploadRequestOption) => handleSaveToDatabase(e)}
                            beforeUpload={handleBeforeUpload}
                            onChange={(info) => {
                                if (info.file.status === 'done') {
                                    message.success('Pomyślnie zapisano menu w bazie danych.')
                                }
                            }}
                            maxCount={1}
                            accept={".pdf"}
                            defaultFileList={menuWeeks}
                            showUploadList={{
                                extra: ({ size = 0 }) => (
                                    <span style={{ color: '#cccccc', marginBottom: 2 }}> ({(size / 1024 / 1024).toFixed(2)}MB)</span>
                                ),
                                showRemoveIcon: true,
                                removeIcon: <CloseCircleOutlined title={"Zamknij"} onClick={(e) => setMenuWeeks([])} />,
                            }}
                            style={{minWidth:'100%'}}
                        >
                            <Button style={{minWidth:'100%'}} type="primary" size={'large'} icon={<UploadOutlined/>}>
                                {pair.second === -1 ? 'Załaduj menu' : 'Uaktualnij menu'}
                            </Button>

                        </Upload>
                    </div>

                    <Button disabled={pair.second === -1} className={'m-2'} style={{width:`${isMobile ? `100%` : `40%`}`}} danger type="primary" size={'large'} icon={<DeleteOutlined/>}
                            onClick={e => handleDelete(pair.second)}>
                        Usuń menu
                    </Button>
                </ConfigProvider>
            </>
        }
        {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
            <Chip style={{width:`${isMobile ? `100%` : `40%`}`}}
                  className={'customTextColor mt-4'}
                  label ={pair.first} />
        }
        {pair.second !== -1 ?
            <ConfigProvider
                theme={{
                    components: {
                        Button: {
                            fontWeight: 500,
                            fontFamily: 'Montserrat, sans-serif',
                            fontSize: 28,
                            colorPrimary: '#C5B5F2',
                            colorPrimaryActive: '#C5B5F2',
                            colorPrimaryHover: '#d4bdff',
                        }
                    }
                }}
            >
                <Button style={{width:`${isMobile ? `100%` : `40%`}`}}
                        className={'py-5 m-2'}
                        type="primary"
                        icon={<FilePdfOutlined />}
                        onClick={e => handleGetPdf(pair.second)}>
                    Pobierz menu
                </Button>
            </ConfigProvider>
            :
            <MenuWeekErrorPage/>
        }
    </>
    )
}